import { init as initReact } from "@instantdb/react";
import schema from "instant.schema";

// FE Client
export const instantClientDB = initReact({
  appId: import.meta.env.VITE_INSTANT_APP_ID,
  schema,
});
